/**
 * Constants
 * */
export const moduleName = `reviews`;

/**
 * Reducer
 * */

export default function reducer(state = {}, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const reviewsSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
